import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Radio } from '@node-space/ui-components'
import { CustomerEntityType } from 'types/customers'
import { CustomerTypeOptions } from '../helpers/form'
import { ConfirmBusinessCustomerMethod, ConfirmCustomerData } from '../helpers/types'
import { AddBusinessCustomer } from './AddBusinessCustomer'

export interface AddCustomerFormProps {
  defaultValues: ConfirmCustomerData
  onConfirm: (customerData: ConfirmCustomerData) => void
  onCancel: () => void
}

export const AddCustomerForm = ({ defaultValues, onConfirm, onCancel }: AddCustomerFormProps) => {
  const { t } = useTranslation()
  const [customerType, setCustomerType] = useState<string>(CustomerEntityType.COMPANY)

  const onConfirmBusinessCustomer: ConfirmBusinessCustomerMethod = businessCustomerData => {
    onConfirm({ business: businessCustomerData })
  }

  return (
    <Box flexCol gap={16}>
      <Radio
        value={customerType}
        onChange={value => setCustomerType(value)}
        horizontal
        options={CustomerTypeOptions?.map(({ label, ...option }) => ({
          ...option,
          label: t(label),
        }))}
      />
      {customerType === CustomerEntityType.COMPANY && (
        <AddBusinessCustomer
          defaultValues={defaultValues?.business?.data}
          onConfirm={onConfirmBusinessCustomer}
          onCancel={onCancel}
        />
      )}
    </Box>
  )
}
